import styled from "styled-components";

const Container = styled.div`
    max-width: 1200px;
    padding: 0 2em;
    margin: 0 auto;
`;

export default Container;